export { default as Desktop } from './Desktop';
export { default as DVDPlayer } from './DVDPlayer';
export { default as Fitness } from './Fitness';
export { default as GameConsole } from './GameConsole';
export { default as Laptop } from './Laptop';
export { default as Printer } from './Printer';
export { default as Router } from './Router';
export { default as SecurityCamera } from './SecurityCamera';
export { default as Speaker } from './Speaker';
export { default as Streaming } from './Streaming';
export { default as Tablet } from './Tablet';
export { default as Thermostat } from './Thermostat';
export { default as TV } from './TV';
export { default as Watch } from './Watch';
export { default as WirelessSpeaker } from './WirelessSpeaker';



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/DeviceIcon/icons/index.ts